import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const badges = [
    { icon: 'Shield', label: 'Enterprise Security' },
    { icon: 'Lock', label: 'SSL Encrypted' },
    { icon: 'CheckCircle2', label: 'GDPR Compliant' }
  ];

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="flex items-center justify-center gap-6 flex-wrap">
        {badges?.map((badge, index) => (
          <div
            key={index}
            className="flex items-center gap-2 text-muted-foreground"
          >
            <Icon name={badge?.icon} size={16} color="var(--color-muted-foreground)" />
            <span className="text-xs">{badge?.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityBadges;